export const Constants = Object.freeze({
  CURRENCY: '$',
  S3_BASE: process.env.VUE_APP_BUCKET_URL,
  MOBILE_BREAK_POINT: 991,
  DEFAULT_BIRTH_DATE: '1950-01-01',
});

export const NOTIFICATION_TYPE = Object.freeze({
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
});

export const USER_TYPE = Object.freeze({
  RIA_USER: 'ria_user',
  CL_USER: 'cl_user',
});

export const TransferInitiatedFrom = Object.freeze({
  ADVISOR: 'ADVISOR',
  CLIENT: 'CLIENT',
  ADVISOR_THEN_CLIENT: 'ADVISOR_THEN_CLIENT',
});

export const RIA_GROUP_ID = Object.freeze({
  SUPER_ADMIN: 1,
  FULL_ADVISOR: 2,
  ADVISOR: 3,
  OPERATIONS: 4,
  NO_ACCESS: 5,
  INVESTMENTS: 6,
  VIEW_ONLY: 7,
});

export const RIA_ACCOUNT_STATUS = Object.freeze({
  INACTIVATED: 0,
  ACTIVATED: 1,
});

export const EMAIL_VERIFICATION = Object.freeze({
  UNVERIFIED: 0,
  VERIFIED: 1,
});

export const MAILING_ACTIVITY = Object.freeze({
  UNACITVE: 0,
  ACTIVE: 1,
});

export const ACCESS_LEVEL = Object.freeze({
  FULL_ACCESS: 1,
  FULL_ACCESS_PRIMARY_SHARED: 2,
  VIEW_ALL_CLIENTS: 3,
  NO_ACCESS: 4,
  VIEW_PRIMARY_SHARED: 5,
});

export const PLATFORM_AREA = Object.freeze({
  ACTIVITY: 'Activity',
  CLIENT_SEGMENTS: 'ClientSegments',
  CLIENTS: 'Clients',
  COMMON: 'COMMON',
  DASHBOARD: 'Dashboard',
  DOCUMENTS: 'Documents',
  GOALS: 'Goals',
  HOLDINGS: 'Holdings',
  INVESTMENT_SETUP: 'Investment Setup',
  INVMODEL: 'InvestmentModels',
  MANAGE_ACCESS: 'ManageAccess',
  RISK_TOLERANCE: 'RiskTolerance',
  PRIVATE_LABEL: 'PrivateLabel',
  SETTINGS: 'Settings',
  SETTINGS_MANAGE_RIA: 'Firm Profile',
  CLIENT_AUTHENTICATION: 'Client Authentication',
  CLIENT_AUTH_BANK_LINKING: 'Bank Linking',
  ADO_SUPERVISOR_APPROVAL: 'Supervision',
});

export const REQUEST_INITIATED_FROM = Object.freeze({
  CLIENT_DASHBOARD: 'clientdashboard',
  ADVISOR_DASHBOARD: 'advisordashboard',
});

/**
 * Below component IDs are in database
 *   ADO_SUPERVISOR_APPROVAL: 22,
 */
/**
 * Below component IDs are not defined in the database.
 * Only use for RwIwantToDropdown mapping
 *
 * GOALS: 20,
 * ACCOUNT: 21,
 * HOUSEHOLD: 22,
 * CLIENTS_HOUSEHOLD: 23,
 * COMMON: 99,
 */
export const COMPONENT_ID = Object.freeze({
  DASHBOARD: 1,
  CLIENTS: 2,
  INVMODEL: 3,
  INVESTMENT_SETUP: 5,
  RISK_TOLERANCE: 6,
  MANAGE_ACCESS: 10,
  PRIVATE_LABEL: 11,
  SETTINGS_MANAGE_RIA: 12,
  DOCUMENTS: 13,
  ACTIVITY: 14,
  SETTINGS: 16,
  CLIENT_SEGMENTS: 17,
  GOALS: 20,
  ACCOUNT: 21,
  HOUSEHOLD: 22,
  CLIENTS_HOUSEHOLD: 23,
  COMMON: 99,
  CLIENT_AUTHENTICATION: 18,
  CLIENT_AUTH_BANK_LINKING: 20,
  ADO_SUPERVISOR_APPROVAL: 22,
});

export const RIA_COMPONENT_ID = Object.freeze({
  DASHBOARD: 'SUMMARY',
  CLIENTS: 'CLIENTS',
  INVESTMENT_MODELS: 'INVESTMENT_MODELS',
  TRANSACTIONS: 'TRANSACTIONS',
  INVESTMENT_SETUP: 'SETTINGS_SECURITY_MAPPING',
  SETTINGS_RISK_TOLERANCE: 'SETTINGS_RISK_TOLERANCE',
  SETTINGS_BATCH_UPLOAD: 'SETTINGS_BATCH_UPLOAD',
  SETTINGS_CRM_CUSTODIAN: 'SETTINGS_CRM_CUSTODIAN',
  SETTINGS_MANAGE_ACCESS: 'SETTINGS_MANAGE_ACCESS',
  SETTINGS_PRIVATE_LABEL: 'SETTINGS_PRIVATE_LABEL',
  SETTINGS_MANAGE_RIA: 'SETTINGS_MANAGE_RIA',
  SETTINGS_MANAGE_DOCUMENTS: 'SETTINGS_MANAGE_DOCUMENTS',
  ACTIVITY: 'ACTIVITY',
  REPORTS: 'REPORTS',
  SETTINGS: 'SETTINGS',
  CLIENT_SEGMENTS: 'CLIENT_SEGMENTS',
  DOCUMENTS: 'SETTINGS_MANAGE_DOCUMENTS',
  CLIENT_AUTH_ACCOUNT_OPENING: 'CLIENT_AUTH_ACCOUNT_OPENING',
  CLIENT_AUTHENTICATION: 'CLIENT_AUTHENTICATION',
  CLIENT_AUTH_BANK_LINKING: 'CLIENT_AUTH_BANK_LINKING',
  ADO_SUPERVISOR_APPROVAL: 'ADO_SUPERVISOR_APPROVAL',
});

export const RIA_COMPONENT = RIA_COMPONENT_ID;

export const COMPONENT_ID_PLATFORM_AREA_MAP = Object.freeze({
  [COMPONENT_ID.DASHBOARD]: PLATFORM_AREA.DASHBOARD,
  [COMPONENT_ID.CLIENTS]: PLATFORM_AREA.CLIENTS,
  [COMPONENT_ID.MANAGE_ACCESS]: PLATFORM_AREA.MANAGE_ACCESS,
  [COMPONENT_ID.PRIVATE_LABEL]: PLATFORM_AREA.PRIVATE_LABEL,
  [COMPONENT_ID.SETTINGS]: PLATFORM_AREA.SETTINGS,
  [COMPONENT_ID.INVMODEL]: PLATFORM_AREA.INVMODEL,
  [COMPONENT_ID.CLIENT_SEGMENTS]: PLATFORM_AREA.CLIENT_SEGMENTS,
  [COMPONENT_ID.DOCUMENTS]: PLATFORM_AREA.DOCUMENTS,
  [COMPONENT_ID.SETTINGS_MANAGE_RIA]: PLATFORM_AREA.SETTINGS_MANAGE_RIA,
  [COMPONENT_ID.RISK_TOLERANCE]: PLATFORM_AREA.RISK_TOLERANCE,
  [COMPONENT_ID.INVESTMENT_SETUP]: PLATFORM_AREA.INVESTMENT_SETUP,
  [COMPONENT_ID.ACTIVITY]: PLATFORM_AREA.ACTIVITY,
  [COMPONENT_ID.CLIENT_AUTHENTICATION]: PLATFORM_AREA.CLIENT_AUTH_ACCOUNT_OPENING,
  [COMPONENT_ID.CLIENT_AUTH_BANK_LINKING]: PLATFORM_AREA.CLIENT_AUTH_BANK_LINKING,
  [COMPONENT_ID.ADO_SUPERVISOR_APPROVAL]: PLATFORM_AREA.ADO_SUPERVISOR_APPROVAL,
  // GOALS: 'TBD'
});

// map the response from /v1/advisor/riaRoleAccessComponents to our internal values
export const PLATFORM_AREA_MAP = Object.freeze({
  'Clients & Households': PLATFORM_AREA.CLIENTS,
  'Manage Access': PLATFORM_AREA.MANAGE_ACCESS,
  'Private Label': PLATFORM_AREA.PRIVATE_LABEL,
  Dashboard: PLATFORM_AREA.DASHBOARD,
  Settings: PLATFORM_AREA.SETTINGS,
  Goals: PLATFORM_AREA.GOALS,
  'Investment Models': PLATFORM_AREA.INVMODEL,
  'Client Segmentation': PLATFORM_AREA.CLIENT_SEGMENTS,
  Documents: PLATFORM_AREA.DOCUMENTS,
  'Firm Profile': PLATFORM_AREA.SETTINGS_MANAGE_RIA,
  'Risk Tolerance': PLATFORM_AREA.RISK_TOLERANCE,
  'Investment Setup': PLATFORM_AREA.INVESTMENT_SETUP,
  'Client Authentication': PLATFORM_AREA.CLIENT_AUTH_ACCOUNT_OPENING,
  'Bank Linking': PLATFORM_AREA.CLIENT_AUTH_BANK_LINKING,
  Supervision: PLATFORM_AREA.ADO_SUPERVISOR_APPROVAL,
});

export const BACKGROUND_IMAGES = Object.freeze([
  {
    image: 'assets/img/background/loginbg_1.png',
    thumb: 'assets/img/background/loginbg_1_thumb.jpg',
  },
  {
    image: 'assets/img/background/loginbg_2.png',
    thumb: 'assets/img/background/loginbg_2_thumb.jpg',
  },
  {
    image: 'assets/img/background/loginbg_3.png',
    thumb: 'assets/img/background/loginbg_3_thumb.jpg',
  },
  {
    image: 'assets/img/background/loginbg_4.png',
    thumb: 'assets/img/background/loginbg_4_thumb.jpg',
  },
  {
    image: 'assets/img/background/loginbg_5.png',
    thumb: 'assets/img/background/loginbg_5_thumb.jpg',
  },
  {
    image: 'assets/img/background/loginbg_6.png',
    thumb: 'assets/img/background/loginbg_6_thumb.jpg',
  },
  {
    image: 'assets/img/background/loginbg_7.png',
    thumb: 'assets/img/background/loginbg_7_thumb.jpg',
  },
  {
    image: 'assets/img/background/loginbg_8.png',
    thumb: 'assets/img/background/loginbg_8_thumb.jpg',
  },
  {
    image: 'assets/img/background/loginbg_9.png',
    thumb: 'assets/img/background/loginbg_9_thumb.jpg',
  },
  {
    image: 'assets/img/background/loginbg_10.png',
    thumb: 'assets/img/background/loginbg_10_thumb.jpg',
  },
]);

export const UI_BRANDING_IMAGES = Object.freeze({
  loginImage: 'assets/img/private-label/login-logo-guide.svg',
  headerImage: 'assets/img/private-label/header-logo-guide.svg',
  faviconImage: 'assets/img/private-label/favicon-logo-guide.svg',
  headerBarImage: 'assets/img/private-label/headerbar.svg',
  navBarImage: 'assets/img/private-label/nav-bar.svg',
  typographyImage: 'assets/img/private-label/typography.svg',
  loginBackgroundImage: 'assets/img/private-label/login-background-image-guide.svg',
});

export const UI_BRANDING_DEFAULT_SETTINGS = Object.freeze({
  headerColor: '#3D586D',
  headerFontColor: '#FFFFFF',
  sidebarColor: '#354552',
  sidebarFontColor: '#FFFFFF',
  fontFamily: 'Open Sans',
  fontSize: '12px',
  bgImage: 'assets/img/background/loginbg_1.png',
});

export const UI_BRANDING_FONT_LIST = Object.freeze([
  'Open Sans',
  'Roboto',
  'Raleway',
  'Droid Sans',
  'Droid Serif',
  'PT Sans',
  'Arvo',
  'Old Standard',
  'Ubuntu',
  'Libre Baskerville',
  'Merriweather',
]);

export const UI_BRANDING_FONT_SIZE_LIST = Object.freeze([
  Object.freeze({text: 'Small', value: '12px'}),
  Object.freeze({text: 'Medium', value: '13px'}),
  Object.freeze({text: 'Large', value: '14px'}),
]);

export const PROP = Object.freeze({
  BOOLEAN_TYPE: Object.freeze({
    type: Boolean,
    required: false,
    default: false,
  }),
  STRING_TYPE: Object.freeze({
    type: String,
    required: false,
    // eslint-disable-next-line no-undefined
    default: undefined,
  }),
});

export const LOGOUT = Object.freeze({
  // 14 min
  TOTAL_SESSION_TIME: 60 * 14,
  // 1 min
  MODAL_TIME_SHOWN: 61,
});

export const TRANSACTIONS = Object.freeze({
  CODES: {
    DEPOSIT: ['DEP', 'REC'],
    WITHDRAWAL: ['WITH', 'DEL'],
    INCOME: ['DIV', 'INT', 'QDV'],
  },
  DEFAULTS: {
    LIMIT: 50,
    LIMITS: [5, 10, 20, 30],
  },
});

export const LOADER_TYPE = Object.freeze({
  CARD: 'card',
  CARDSROW: 'cards-row',
  CLIENTACCOUNTS: 'client-accounts',
  CLIENTGOALS: 'client-goals',
  CLIENTGRAPH: 'client-graph',
  CLIENTSUMMARYINFO: 'client-summary-info',
  CONTACTINFO: 'contact-info',
  DASHBOARDGRAPH: 'dashboard-graph',
  DASHBOARDLIST: 'dashboard-list',
  GOALOVERVIEW: 'goal-overview',
  GOALSUMMARY: 'goal-summary',
  HEADING: 'heading',
  MODELPORTFOLIO: 'model-portfolio',
  OPENACCOUNT: 'open-account',
  OVERVIEW: 'overview',
  TABLE: 'loader-table',
  STANDARD: 'standard',
  WIDGET: 'widget',
  WIDGETGROUP: 'widget-group',
  CLIENTACCOUNTSEARCH: 'client-account-search',
});

export const LOADER_DISPLAY_TYPE = Object.freeze({
  RECTANGLE: 'RECTANGLE',
  SQUARE: 'SQUARE',
});

export const CLIENT_PERFORMANCE = {
  RETURN_TYPE: {
    CUMULATIVE: 'Cumulative',
    ANNUALIZED: 'Annualized',
  },

  ADVISOR_FEE_TYPE: {
    GROSS: 'Gross',
    NET: 'Net',
  },
};

export const MAX_LINKED_COUNT = 5;

export const USER_DELETED = '0';

export const CUSTODIAN = Object.freeze({
  APEX: 7,
  TD: 1,
});

export const CUSTODIAN_MAP = Object.freeze({
  [CUSTODIAN.APEX]: 'APEX',
  [CUSTODIAN.TD]: 'TD',
});

export const TRANSFER_DIRECTION = Object.freeze({
  DEPOSIT: 1,
  WITHDRAWAL: 2,
});

export const TRANSFER_DESCRIPTION = Object.freeze({
  [TRANSFER_DIRECTION.DEPOSIT]: 'Deposit',
  [TRANSFER_DIRECTION.WITHDRAWAL]: 'Withdrawal',
});

export const NEW_BANK_ACCOUNT = Object.freeze({
  ID: 0,
  TYPE: 'New Bank',
  NAME: 'Link New Bank',
});

export const MONEY_TRANSFER_TYPE = Object.freeze({
  CREATE_NEW_INSTRUCTIONS: 0,
  REPLACE_ALL_INSTRUCTIONS: 2,
});

export const MONEY_TRANSFER_STATUS = Object.freeze({
  COMPLETE: 0,
  REQUESTED: 1,
});

export const TRANSFER_CODE = Object.freeze({
  DEP: 'DEP',
  REC: 'REC',
  WITH: 'WITH',
  DEL: 'DEL',
  DIV: 'DIV',
  INT: 'INT',
  QDV: 'QDV',
});

export const TRANSFER_CODE_DIRECTION = Object.freeze({
  [TRANSFER_DIRECTION.DEPOSIT]: [
    TRANSFER_CODE.DEP,
    TRANSFER_CODE.REC,
    TRANSFER_CODE.INT,
    TRANSFER_CODE.DIV,
    TRANSFER_CODE.QDV,
  ],
  [TRANSFER_DIRECTION.WITHDRAWAL]: [TRANSFER_CODE.WITH, TRANSFER_CODE.DEL],
});

export const TRANSFER_CODE_DESCRIPTION = Object.freeze({
  [TRANSFER_CODE.DEP]: 'Deposit',
  [TRANSFER_CODE.REC]: 'Security transfer',
  [TRANSFER_CODE.WITH]: 'Withdrawal',
  [TRANSFER_CODE.DEL]: 'Security transfer',
  [TRANSFER_CODE.DIV]: 'Dividends',
  [TRANSFER_CODE.INT]: 'Interest',
  [TRANSFER_CODE.QDV]: 'Qualified Dividends',
});

export const TRANSFER_CODE_OPERATION = Object.freeze({
  [TRANSFER_CODE.DEP]: 'has been made to',
  [TRANSFER_CODE.REC]: 'invested into',
  [TRANSFER_CODE.WITH]: 'has been made from',
  [TRANSFER_CODE.DEL]: 'withdrawn from',
  [TRANSFER_CODE.DIV]: 'reinvested into',
  [TRANSFER_CODE.INT]: 'reinvested into',
  [TRANSFER_CODE.QDV]: 'reinvested into',
});

export const DISTRIBUTION_MODE = Object.freeze({
  ACH: 'ACH',
  CHECK: 'CHECK',
});

export const TRANSFER_TYPE = Object.freeze({
  INCOME: [TRANSFER_CODE.INT, TRANSFER_CODE.DIV, TRANSFER_CODE.QDV],
  WITHDRAWAL: [TRANSFER_CODE.WITH, TRANSFER_CODE.DEL],
  DEPOSIT: [TRANSFER_CODE.DEP, TRANSFER_CODE.REC],
});

export const TRANSFER_TYPE_DESCRIPTION = Object.freeze({
  INCOME: 'Income',
  WITHDRAWAL: 'Withdrawal',
  DEPOSIT: 'Deposit',
});

export const TRANSFER_ACCOUNT_DESCRIPTION = Object.freeze({
  BANK: 'Bank Account',
  BROKERAGE: 'Brokerage Account',
});

export const TRANSFER_MONEY_DESCRIPTION = {
  deposit: 'Deposit',
  withdrawal: 'Withdrawal',
};

export const TRANSFER_MONEY_INITIATED_FROM_ID = {
  ADVISOR: 2,
};

export const TRANSFER_MONEY = {
  [TRANSFER_MONEY_DESCRIPTION.deposit]: 1,
  [TRANSFER_MONEY_DESCRIPTION.withdrawal]: 2,
};

export const HOUSEHOLD = {
  household: 'household',
};

export const IRA_ACCOUNT_TYPE = {
  INDIVIDUAL: 'Individual',
  SIMPLE_IRA: 'SIMPLE IRA',
  ROTH_IRA: 'Roth IRA',
  TRADITIONAL_IRA: 'Traditional IRA',
  SEP_IRA: 'SEP IRA',
};

export const FREQUENCIES = {
  ONE_TIME: '1',
  WEEKLY: '2',
  MONTHLY: '3',
  QUARTERLY: '4',
  ANNUALLY: '5',
};

export const FREQUENCY_CODES = {
  ONE_TIME: 'ONE_TIME',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  ANNUALLY: 'ANNUALLY',
};

export const FREQUENCY_LABEL = {
  ONE_TIME: 'one time',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  ANNUALLY: 'annually',
};

export const TRANSACTION_STATUS_CODE = {
  SCHEDULED: 'SCHEDULED',
  AWAITING_CLIENT_ACTION: 'AWAITING_CLIENT_ACTION',
  AWAITING_CLIENT_CONFIRMATION: 'AWAITING_CLIENT_CONFIRMATION',
  AWAITING_DOCUMENTATION: 'AWAITING_DOCUMENTATION',
  AWAITING_MICRODEPOSIT_VERIFICATION: 'AWAITING_MICRODEPOSIT_VERIFICATION',
  AUTOMATED_MICRODEPOSIT_VERIFICATION_PENDING: 'AUTOMATED_MICRODEPOSIT_VERIFICATION_PENDING',
  DOCUMENTATION_REQUIRED: 'DOCUMENTATION_REQUIRED',
  IN_PROCESS: 'IN_PROCESS',
  LIQUIDATION_INITIATED: 'LIQUIDATION_INITIATED',
  PENDING: 'PENDING',
  PENDING_REVIEW: 'PENDING_REVIEW',
  PENDING_VERIFICATION: 'PENDING_VERIFICATION',
};

export const ACCOUNT_TYPE_ID = Object.freeze({
  INDIVIDUAL: 3,
  SIMPLE_IRA: 14,
  ROTH_IRA: 1,
  TRADITIONAL_IRA: 2,
  SEP_IRA: 13,
});

export const CLIENT_ACCOUNT_TYPES = {
  LINKED: 'Linked',
};

export const ACCOUNT_REQUEST_STATUS = Object.freeze({
  FINISH_OWNER_INFORMATION: 1,
  FINISH_BENEFICIARIES: 2,
  FINISH_ADDITIONAL_INFORMATION: 3,
  FINISH_REVIEW: 4,
  PENDING_VERIFICATION: 5,
  DOCUSIGN_SENT: 6,
  PENDING_ACCOUNT_OPENING: 7,
  LINKED: 8,
  CANCELLED: 9,
  ERROR: 10,
});

export const ASSET_IMAGES = {
  NO_DATA: 'assets/img/NoDataIcon.svg',
  NO_DATA_ADD_NEW: 'assets/img/mp_no_data.svg',
  NO_DATA_GRAPH: 'assets/img/NoDataGraphIcon.svg',
  OPEN_ACCOUNT: 'assets/img/open-account.svg',
  NO_SEARCH_DATA: 'assets/img/VisualEmptyStates_NoData.svg',
  NO_CUSTODIAN_DATA: 'assets/img/Visual_Empty_StatesCheck.svg',
};

export const TRANSFER_CANCELED_FROM = {
  Advisor: 'ADVISOR',
};

export const BENEFICIARY_TYPES = {
  PRIMARY: 'PRIMARY',
  CONTINGENT: 'CONTINGENT',
};

export const APP_DATE_SETTINGS = {
  FORMAT: 'YYYY-MM-DD',
};

export const DATE_FNS_SETTINGS = {
  FORMAT: 'yyyy-MM-dd',
};

export const MARITAL_STATUSES = {
  MARRIED: 'Married',
  SINGLE: 'Single',
  DIVORCED: 'Divorced',
  WIDOWED: 'Widowed',
};

export const GOAL_TYPE = Object.freeze({
  CLIENT_GOAL: 1,
  HOUSEHOLD_GOAL: 2,
});

export const CASH_SWEEP_VEHICLE_IDS = [1, 2];

/**
 * first is Apex Account Status and second is apex account request status
 * @type {{APEX_STATUS_FINISH_ADDITIONAL_INFORMATION: string, APEX_PENDING_PENDING_ACCOUNT_OPENING: string, APEX_ACTION_REQUIRED_PENDING_ACCOUNT_OPENING: string, APEX_STATUS_PENDING_VERIFICATION: string, APEX_STATUS_ERROR: string, APEX_STATUS_FINISH_REVIEW: string, APEX_STATUS_DOCUSIGN_SENT: string, APEX_STATUS_PENDING_ACCOUNT_OPENING: string, APEX_STATUS_FINISH_BENEFICIARIES: string, APEX_SUSPENDED_PENDING_ACCOUNT_OPENING: string, APEX_STATUS_FINISH_OWNER_INFORMATION: string}}
 */
export const APEX_STATUS_COMBO = {
  APEX_STATUS_FINISH_OWNER_INFORMATION: 'null-1',
  APEX_STATUS_FINISH_BENEFICIARIES: 'null-2',
  // eslint-disable-next-line id-length
  APEX_STATUS_FINISH_ADDITIONAL_INFORMATION: 'null-3',
  APEX_STATUS_FINISH_REVIEW: 'null-4',

  APEX_STATUS_PENDING_VERIFICATION: 'null-5',
  APEX_STATUS_DOCUSIGN_SENT: 'null-6',

  APEX_STATUS_PENDING_ACCOUNT_OPENING: 'null-7',
  APEX_PENDING_PENDING_ACCOUNT_OPENING: '2-7',
  // eslint-disable-next-line id-length
  APEX_ACTION_REQUIRED_PENDING_ACCOUNT_OPENING: '4-7',
  APEX_SUSPENDED_PENDING_ACCOUNT_OPENING: '5-7',
  APEX_STATUS_ERROR: 'null-10',
};

export const DASHBOARD = {
  ADVISOR_DASHBOARD: 'advisordashboard',
  CLIENT_DASHBOARD: 'clientdashboard',
  RDK_PUBLICAPI: 'rdkPublicApi',
};

export const TAX_SETTINGS = Object.freeze({
  OPTIONS: [
    {id: 1, title: 'Both', text: 'Both'},
    {id: 2, title: 'Taxable', text: 'Taxable'},
    {id: 3, title: 'Tax-Advantaged', text: 'Tax-Advantaged'},
  ],
  TAXABLES: [1, 2, 4],
  NON_TAXABLES: [1, 3, 4],
  TEXTS: ['Both', 'Taxable', 'Tax-Advantaged'],
  NAMES: ['Both', 'Taxable', 'Tax-Advantaged'],
  STATUSES: {
    Both: 1,
    Taxable: 2,
    TaxAdvantaged: 3,
    Mixed: 4,
  },
  SLEEVE_NAMES: {
    1: 'Both',
    4: 'Mixed',
  },
});

export const CHARACTER_LIMIT = {
  STANDARD: 30,
  NAME: 45,
  ADDRESS_ZIP: 5,
  CRD_NUMBER: 6,
  REP_CODE: 5,
  DESCRIPTION: 250,
};

export const REPCODE_INTEGRATION_STATUS = {
  1: 'Pending',
  2: 'Complete',
};

export const REPCODE_DATA_SYNC = {
  UPDATED: 1,
};

export const PORTFOLIO_TYPES = {
  CURRENT: 'current',
  TARGET: 'target',
};

export const PORTFOLIO_CREATOR_TYPES = [
  {name: 'Advisor Portfolio', isCustom: true},
  {name: 'Manager Portfolio', isCustom: false},
];

export const ASSET_MANAGER_ID = 2;

export const CALCULATION_FREQUENCY_TYPE = Object.freeze({
  DAILY: 1,
  MONTHLY: 3,
  QUARTERLY: 4,
  ANNUALLY: 5,
});

export const FEES_TYPE = Object.freeze({
  ARREARS: 1,
  IN_ADVANCE: 2,
});

export const AUM_TIER_TYPES = Object.freeze({
  FLAT: 'FLAT',
  CLIFF: 'CLIFF',
  BLENDED: 'BLENDED',
});

export const FEE_SCHEDULE_TYPE = Object.freeze({
  DEFAULT: 'Default Fee Schedule',
});

export const DATATABLECONSTANTS = Object.freeze({
  ITEMS_PER_PAGE_OPTIONS: [5, 10, 15, 20],
  ITEMS_PER_PAGE: 5,
  ASSIGNED_DATA_ERROR_MESSAGE: 'Please assign selected clients/accounts.',
  NONE: 'None',
  SELECT_ATLEAST_CLIENT_ACCOUNT: 'Please select one or multiple clients/accounts.',
});

export const FEATURE_CONSTANTS = Object.freeze({
  RISK_TOL_QUEST: 'RISK_TOL_QUEST',
  BANK_TRANSFER: 'BANK_TRANSFER',
  OPEN_ACCOUNT: 'OPEN_ACCOUNT',
  ADD_EDIT_DELETE_GOAL: 'ADD_EDIT_DELETE_GOAL',
  ACATS: 'ACATS',
  ACATS_CASH_ONLY: 'ACATS_CASH_ONLY',
  RISK_TOL_OVERRIDE: 'RISK_TOL_OVERRIDE',
  FEE_SCHEDULE: 'FEE_SCHEDULE',
  PERFORMANCE_REPORTING: 'PERFORMANCE_REPORTING',
  WEALTH_PROJECTION_GOAL: 'WEALTH_PROJECTION_GOAL',
  WEALTH_PROJECTION_ACCOUNT: 'WEALTH_PROJECTION_ACCOUNT',
  INDIVIDUAL: 'INDIVIDUAL',
  TRADITIONAL_IRA: 'TRADITIONAL_IRA',
  ROTH_IRA: 'ROTH_IRA',
  TOTAL_CASH_VALUE_BOX: 'TOTAL_CASH_VALUE_BOX',
  TOTAL_ACCOUNTS_CASH_BOX: 'TOTAL_ACCOUNTS_CASH_BOX',
  TOTAL_GOALS_CASH_BOX: 'TOTAL_GOALS_CASH_BOX',
  ATTACH_ACCOUNT: 'ATTACH_ACCOUNT',
  CURRENT_PORTFOLIO_ACCOUNT: 'CURRENT_PORTFOLIO_ACCOUNT',
  TARGET_PORTFOLIO_ACCOUNT: 'TARGET_PORTFOLIO_ACCOUNT',
  CURRENT_PORTFOLIO_GOAL: 'CURRENT_PORTFOLIO_GOAL',
  TARGET_PORTFOLIO_GOAL: 'TARGET_PORTFOLIO_GOAL',
  SEP_IRA: 'SEP_IRA',
  SIMPLE_IRA: 'SIMPLE_IRA',
  ACCOUNT_AGGREGATION: 'ACCOUNT_AGGREGATION',
  ACCOUNT_MINIMUM_AMOUNT: 'ACCOUNT_MINIMUM_AMOUNT',
  CLIENT_MINIMUM_AMOUNT: 'CLIENT_MINIMUM_AMOUNT',
});

export const FEATURE_CONSTANT_IDS = Object.freeze({
  [FEATURE_CONSTANTS.ACCOUNT_MINIMUM_AMOUNT]: 36,
  [FEATURE_CONSTANTS.CLIENT_MINIMUM_AMOUNT]: 38,
});

export const UI_ACTION = Object.freeze({
  OK: 'OK',
  ACCEPT: 'Accept',
  CANCEL: 'Cancel',
  CLOSE: 'Close',
  EDIT: 'Edit',
  DELETE: 'Delete',
  PRINT: 'Print',
  YES: 'Yes',
  NO: 'No',
  CONFIRM: 'Confirm',
  SAVE: 'Save',
  APPROVE: 'Approve',
  REJECT: 'Reject',
  REMINDER: 'Send Reminder Email',
  EXIT: 'Exit',
});

export const UI_EVENT = Object.freeze({
  [UI_ACTION.OK]: 'rw-ok',
  [UI_ACTION.ACCEPT]: 'rw-accept',
  [UI_ACTION.CANCEL]: 'rw-cancel',
  [UI_ACTION.CLOSE]: 'rw-close',
  [UI_ACTION.EDIT]: 'rw-edit',
  [UI_ACTION.DELETE]: 'rw-delete',
  [UI_ACTION.PRINT]: 'rw-print',
  [UI_ACTION.YES]: 'rw-yes',
  [UI_ACTION.NO]: 'rw-no',
  [UI_ACTION.SAVE]: 'rw-save',
  [UI_ACTION.APPROVE]: 'rw-approve',
  [UI_ACTION.REJECT]: 'rw-reject',
  [UI_ACTION.REMINDER]: 'rw-reminder',
});

export const UI_LEVEL = Object.freeze({
  CLIENT: 'client',
  ADVISOR: 'advisor',
});

export const UI_ELEMENTS = Object.freeze({
  LINKED_BANK_ROWS: {QTY: 4, LG: 3, MD: 6, SM: 12, COLS: 12},
  BROKERAGE_ACCOUNTS_ROWS: {QTY: 4, LG: 3, MD: 6, SM: 12, COLS: 12},
  BENE_ACCOUNT_ROWS: {QTY: 4, LG: 3, MD: 4, SM: 12, COLS: 12},
});

export const UI_EMAIL_TEMPLATE = Object.freeze({
  BANKLINK: 'bankLinkRequestedToClient',
  RTQEMAILTOCLIENT: 'riskToleranceRetakeAdvToClient',
});

export const DOCUMENTS = Object.freeze({
  PREVIEW_FORMAT: 'pdf',
  PREVIEW_MIME_TYPE: 'application/pdf',
  EXAMPLE_DOCUMENT_NAME: 'Example Document Template',
});

export const FILTER_FEE_SCHEDULE = Object.freeze({
  DEFAULTED: 'defaulted',
  ALL: 'all',
  SPECIFIC: 'specific',
  UNASSIGNED: 'unassigned',
});

export const DOCUMENTS_TAB = Object.freeze({
  DOCUMENT: 0,
  WORKFLOW: 1,
});

export const CUSTODIAN_DETAILS = {
  APEX: {
    name: 'Apex',
    objectKey: 'apexCount',
    routeKey: 'apex',
  },
  TD: {
    name: 'TD',
    objectKey: 'tdCount',
    routeKey: 'td',
  },
};

export const BANK_LINK_STATUS = Object.freeze({
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
});

const INVESTMENT_SETUP_SECTIONS = Object.freeze({
  ASSET_CLASS: 'asset-class',
  SECURITY_CLASSIFICATION: 'security-classification',
});

export const INVESTMENT_SETUP = Object.freeze({
  SECTIONS: INVESTMENT_SETUP_SECTIONS,
});

export const RTQ_SHRINKAGE_FACTOR_CONSTANTS = Object.freeze({
  NONE: 'None',
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
});

export const RISK_TOLERANCE_SHRINKAGE_FACTOR = Object.freeze({
  [RTQ_SHRINKAGE_FACTOR_CONSTANTS.NONE]: -1,
  [RTQ_SHRINKAGE_FACTOR_CONSTANTS.LOW]: 100,
  [RTQ_SHRINKAGE_FACTOR_CONSTANTS.MEDIUM]: 50,
  [RTQ_SHRINKAGE_FACTOR_CONSTANTS.HIGH]: 5,
});

export const ROBO_STATUS = Object.freeze({
  OFF: 0,
  ON: 1,
  PENDING: 2,
});

export const ESIGNATURE_STATUS = Object.freeze({
  SENT: 'sent',
  RESENT: 'resend',
  COMPLETED: 'completed',
  VOID: 'voided',
});

export const ESIGNATURE_STATUS_TEXT = Object.freeze({
  [ESIGNATURE_STATUS.SENT]: 'Sent',
  [ESIGNATURE_STATUS.RESENT]: 'Resent',
  [ESIGNATURE_STATUS.COMPLETED]: 'Completed on ',
  [ESIGNATURE_STATUS.VOID]: 'Voided',
});

export const ESIGNATURE_PROCESS = Object.freeze({
  LPOA: 4,
  BANK_TRANSFER: 5,
  ACCOUNT_OPENING: 6,
  CLIENT_ONBOARDING: 8,
});

export const ESIGNATURE_PROCESS_DESCRIPTION = Object.freeze({
  [ESIGNATURE_PROCESS.LPOA]: 'LPOA',
  [ESIGNATURE_PROCESS.BANK_TRANSFER]: 'Bank Transfer',
  [ESIGNATURE_PROCESS.ACCOUNT_OPENING]: 'Account Opening',
  [ESIGNATURE_PROCESS.CLIENT_ONBOARDING]: 'Client Onboarding Workflow',
});

export const ESIGNATURE_VALID = Object.freeze({
  STATUS: [ESIGNATURE_STATUS.SENT, ESIGNATURE_STATUS.RESENT, ESIGNATURE_STATUS.COMPLETED, ESIGNATURE_STATUS.VOID],
  PROCESS: [
    ESIGNATURE_PROCESS.LPOA,
    ESIGNATURE_PROCESS.BANK_TRANSFER,
    ESIGNATURE_PROCESS.ACCOUNT_OPENING,
    ESIGNATURE_PROCESS.CLIENT_ONBOARDING,
  ],
  FOR_PREVIEW: [ESIGNATURE_STATUS.SENT, ESIGNATURE_STATUS.RESENT, ESIGNATURE_STATUS.COMPLETED],
  FOR_RESEND: [ESIGNATURE_STATUS.SENT, ESIGNATURE_STATUS.RESENT],
  FOR_VOIDING: [ESIGNATURE_STATUS.SENT, ESIGNATURE_STATUS.RESENT],
});

export const ESIGNATURE_DOCUMENT_TYPE = Object.freeze({
  DOCUSIGN: 'docusign',
  WORKFLOW: 'workflow',
});

export const ENTERPRISE_FEATURES = Object.freeze({
  SSO: 'SSO',
});

export const SSO_REDIRECT_URI = 'advisorlogin';

export const TICKER_WEIGHT = Object.freeze({
  MIN: 0.25,
  MAX: 100,
});

export const DIVIDEND_SETTINGS = Object.freeze([
  {
    label: 'Re-invest dividends',
    value: 'REINVEST_DIVIDENDS',
  },
  {
    label: 'Set dividends to cash',
    value: 'SET_DIVIDENDS_TO_CASH',
  },
]);

export const TRANSACTION_TYPES = Object.freeze([
  'Buy',
  'Sell',
  'Deposit',
  'Withdrawal',
  'Security In',
  'Security Out',
  'Dividend',
  'Interest',
  'Expense',
  'Advisory Fees',
  'Corporate Action',
]);

export const ACCOUNT_INVESTIGATION_HISTORY_DOCUMENT_REQUEST_RESEND = 2;

export const CLIENT_DOC_UPLOAD_MAX_SIZE_MB = 8;

export const FILE_PREVIEW_ERROR_MESSAGE =
  'Something went wrong when the document preview was being created. Please download the file to view it.';

export const ACCOUNT_PORTFOLIO_TYPE = Object.freeze({
  GOAL_BASED_PORTFOLIO: 'Goal Based',
  RISK_BASED_PORTFOLIO: 'Risk Based',
});

export const BENEFICIARIES_TRUSTED_ENUM = Object.freeze({
  'Roth IRA': {ENUM: 'ROTH_IRA', VALUE: 'Roth IRA', ID: 1},
  'Traditional IRA': {ENUM: 'TRADITIONAL_IRA', VALUE: 'Traditional IRA', ID: 2},
});

export const StateTaxWithholdingValueType = Object.freeze({
  PERCENTAGE: 'PERCENTAGE',
  FIXED: 'FIXED',
});
